export default function Civil() {
    return (
        <div>
            <h1>Mariage civil</h1>
            <div className="info-container">
                <img width='300' src="images/civil.jpg" alt="Sam & Nina" className="info-photo" />
                <h2>Date : Le 20 mai 2026 à 15h00</h2>
                <h2>Lieu : Maison communale de Sambreville<br />
                    Grand'Place 1, 5060 Sambreville</h2>
                <h2>Et après ?</h2>
                <p> Rendez-vous à la maison <br />
                    136 Rue de Falisolle, 5060 Auvelais
                </p>
                <p>En mode auberge espagnole, bienvenue qui veut, on poussera les murs au besoin.</p>
            </div>

        </div>
    );
}

